export const IN_CHUNK = 100;

export function chunkArray<T>(arr: T[], size: number = IN_CHUNK): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}

export async function fetchInChunks<T = any>(
  ids: readonly (string | number)[],
  fetcher: (parte: (string | number)[]) => any,
  size: number = IN_CHUNK
): Promise<{ data: T[]; error: any }> {
  if (!ids.length) return { data: [], error: null };
  const results: any[] = await Promise.all(chunkArray([...ids], size).map((parte) => fetcher(parte)));
  const error = results.find((r) => r?.error)?.error ?? null;
  const data = results.flatMap((r) => r?.data || []) as T[];
  return { data, error };
}
